import { Schedule } from '../models';

const hhmm = (hour: number, minute: number, ampm: boolean) => {
  const am = hour < 12;
  const ampmString = am ? 'am' : 'pm';
  const adjustedHour = (hour + 11) % 12 + 1;
  if (minute === 0) {
    return `${adjustedHour}${ampm ? ampmString : ''}`;
  } else {
    return `${adjustedHour}:${minute}${ampm ? ampmString : ''}`
  }
}

const TIME_PATTERN = /^(\d+):(\d+)([:]\d+)?$/;

const getTimeString = (startsAt: string, length: number) => {
  const match = TIME_PATTERN.exec(startsAt);
  if (!match) {
    throw new Error(`startsAt in unexpected format: ${startsAt}`);
  }
  const [_, stringHour, stringMinute] = match;
  const startHour = parseInt(stringHour)
  const startMinute = parseInt(stringMinute)
  const endHour = (startHour + Math.floor((startMinute + length) / 60)) % 24
  const endMinute = (startMinute + length) % 60;
  return `${hhmm(startHour, startMinute, false)}-${hhmm(endHour, endMinute, true)}`;
}

const WEEKDAYS = [
  'Sundays',
  'Mondays',
  'Tuesdays',
  'Wednesdays',
  'Thursdays',
  'Fridays',
  'Saturdays',
];

export const parseSchedule = (schedule: Schedule) => {
  return `${WEEKDAYS[schedule.isoWeekday % 7]} ${getTimeString(schedule.startsAt, schedule.lengthMinutes)}`;
};
